import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@app/core/core.module';
import { CreateOrderComponent } from '@app/ui/order/create-order/create-order.component';
import { ValidateOrderComponent } from '@app/ui/order/validate-order/validate-order.component';
import { MatDividerModule } from '@angular/material/divider';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { OrderSummaryContainerComponent } from './order-summary-container/order-summary-container.component';
import { OrderRoutingModule } from '@app/ui/order/order-routing.module';

@NgModule({
    imports: [CommonModule, CoreModule, OrderRoutingModule, MatDividerModule],
    declarations: [
        CreateOrderComponent,
        ValidateOrderComponent,
        OrderSummaryComponent,
        OrderSummaryContainerComponent,
    ],
    providers: [],
})
export class OrderModule {}
